import { IDeviceService } from "../../service/device/DeviceService";
import { IUserCredential } from "../../model/user/UserCredential";
import { ICredentialService } from "../../service/credential/CredentialService";

export default class GetDevicesInteractor {
  private deviceService: IDeviceService;
  private credentialService: ICredentialService;

  constructor({
    deviceService,
    credentialService
  }: {
    deviceService: IDeviceService;
    credentialService: ICredentialService;
  }) {
    this.deviceService = deviceService;
    this.credentialService = credentialService;
  }

  async execute(userCredentials: IUserCredential) {
    const devices = await this.deviceService.getDevices(userCredentials);
    await this.credentialService.setLoggedIn(true);
    return devices;
  }
}
